module.exports = __webpack_public_path__ + "static/img/52.21a20728.gif";